export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/ee.ad47e7eb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};